import { type BaseIssue, type BaseSchema, boolean, object, optional, string } from "valibot";

export function wrapWithRpcResponseSchema<T = unknown>(dataSchema: BaseSchema<unknown, T, BaseIssue<unknown>>) {
  return object({
    success: boolean(),
    errorMessage: optional(string()),
    data: optional(dataSchema),
  });
}

export interface IRpcResponse<T> {
  success: boolean;
  errorMessage?: string;
  data?: T;
}

export interface RpcContract<TName extends string, TParams, TResult> {
  name: TName;
  paramsSchema: BaseSchema<unknown, TParams, BaseIssue<unknown>>;
  resultSchema: BaseSchema<unknown, TResult, BaseIssue<unknown>>;
}

export const rpcContract = <const TRpcName, TRpcParams, TRpcResult>(input: {
  name: TRpcName;
  paramsSchema: BaseSchema<unknown, TRpcParams, BaseIssue<unknown>>;
  resultSchema: BaseSchema<unknown, TRpcResult, BaseIssue<unknown>>;
}) => input;
